import { FieldGroup } from '@/components/ui/field.tsx';
import type { Product } from '@/types/product.type';
import ProductCheckbox from '@/views/products/components/ProductCheckbox.tsx';

type Props = {
  allProducts: Product[];
  selectedProductIds: string[];
  onSelectedChange: (selectedProductIds: string[]) => void;
};

export default function ProductCheckboxGroup({
  allProducts,
  selectedProductIds,
  onSelectedChange,
}: Props) {
  return (
    <FieldGroup
      data-slot="product-checkbox-group"
      className="grid grid-cols-[repeat(auto-fill,min(100%/2-1.25rem,155px))] justify-center gap-x-5 gap-y-6 sm:justify-start"
    >
      {allProducts.map((product) => (
        <ProductCheckbox
          key={product.uuid}
          product={product}
          checked={selectedProductIds.some((id) => id === product.uuid)}
          onCheckedChange={(checked) => {
            onSelectedChange(
              checked
                ? [...selectedProductIds, product.uuid]
                : selectedProductIds.filter((id) => id !== product.uuid)
            );
          }}
        />
      ))}
    </FieldGroup>
  );
}
